import { useAppSelector } from '../../hooks';
import useAccountAlertData from '../../hooks/useAccountAlertData';
import { selectAccountName, selectScopes, selectUserEmail } from '../../selectors';
import memoWithDisplayName from '../../utils/memoWithDisplayName';
import Alert from '../../nav-ui-components/Alert/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export const AccountAlert = memoWithDisplayName('AccountAlert', () => {
  const accountName = useAppSelector(selectAccountName);
  const scopes = useAppSelector(selectScopes);
  const userEmail = useAppSelector(selectUserEmail);
  const alertProps = useAccountAlertData({
    accountName,
    userEmail,
    scopes
  });
  return alertProps ? /*#__PURE__*/_jsx(Alert, Object.assign({}, alertProps)) : null;
});